<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 overflow-hidden bg-smoke-light flex">
		<div class="relative bg-grey-lightest w-full max-w-md m-auto flex-col flex rounded m-8 overflow-scroll">
			<div class="flex py-2 m-2 px-4">
				<div class="flex-1 text-left">
					<p class="text-2xl font-light inline">Välj inställningar för sidan</p>
				</div>
				<div class="flex-1">
					<button @click="dismissModal()" class="flex items-center justify-center w-24 float-right py-2 pr-2 text-sm text-center text-white block bg-grey hover:bg-grey-dark rounded shadow-light font-bold">
						Stäng
					</button>
				</div>
			</div>

			<div class="h-full bg-grey-light rounded mx-6 mb-6 py-8">
				
				<div class="w-3/5 m-auto mt-6">
					<p class="text-left mb-2">Analys</p>
					<div class="relative">
						<select v-model="interpolationType" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
							<option v-for="type in filteredAnalysisTypes" :key="type.slug" :value="type.slug" v-text="type.title"></option>
						</select>
						<div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
							<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
						</div>
					</div>
				</div>
				
				<div class="w-3/5 m-auto mt-6">
					<p class="text-left mb-2">Interpoleringsalgoritm</p>
					<div class="relative">
						<select v-model="interpolationAlgorithm" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
							<option value="1">Traditionell</option> 
							<option value="3">Ny interpolationsteknik</option>
						</select>
						<div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
							<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
						</div>
					</div>
					<div class="text-left ml-4 mt-1">
						<input class="mr-2" type="checkbox" v-model="interpolationColorSmoothing">
						<span class="text-sm"> Använd mjuka färgövergångar</span>
					</div>
				</div>

				<div class="w-3/5 m-auto mt-6">
					<button @click="saveSettings()" class="float-right py-2 px-2 text-sm text-center text-white block bg-green hover:bg-green-dark rounded shadow-light font-bold">
						Spara inställningar
					</button>
				</div>

			</div>

		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {

	data() {
		return {
			show: false,
			interpolationType: 'ph',
			interpolationAlgorithm: 1,
			interpolationColorSmoothing: 0,
		}
	},

	computed: {
		...mapGetters({
			analysisTypes:		'analysis/types',
			currentAnalyses:	'layout/currentAnalyses',
		}),

		/**
		 *	Will filter the analyses to only show the 
		 *	ones that exist among the samples
		 */
		filteredAnalysisTypes() {
			if(Object.keys(this.currentAnalyses).length) {
				return this.analysisTypes.filter(type => {
					return this.currentAnalyses[type.slug] && this.currentAnalyses[type.slug] > 0
				})
			}
			return this.analysisTypes
		}
	},

	mounted() {
		bus.$on('open-global-settings-modal', this.openModal)
		bus.$on('close-global-settings-modal', this.dismissModal)
	},

    beforeDestroy() {
        bus.$off('open-global-settings-modal', this.openModal)
        bus.$off('close-global-settings-modal', this.dismissModal)
    },

	methods: {
		openModal() {
			this.show = true
			document.getElementById("body").className = "overflow-y-hidden";
			bus.$emit('deselect')
		},
		
		dismissModal() {
			this.show = false
			document.getElementById("body").className = "";
		},

		saveSettings() {
			this.$store.dispatch("layout/SET_GLOBAL_SETTINGS", {
				interpolationType: this.interpolationType,
				interpolationAlgorithm: this.interpolationAlgorithm,
				interpolationColorSmoothing: this.interpolationColorSmoothing,
			})

			this.dismissModal()
		}
	}
}
</script>